const WebInputField = Object.freeze({
  TOGGLEBUTTON: 'toggle-button',
  CHECKBOX: 'checkbox',
  TEXTAREA: 'text-area',
});

const RoleField = Object.freeze({
  READ: 'read',
  WRITE: 'write',
  HIDDEN: 'hidden',
});

export { WebInputField, RoleField };
